import { addWordDiffToDiffs } from '@atlassian/bitkit-diff/exports/diff-to-word-diff';
import { amendChunks } from '@atlassian/bitkit-diff/exports/util/amend-chunks';
// @ts-ignore TODO: fix noImplicitAny error here
import diffParser from '@atlassian/diffparser';

import { Diff } from 'src/types/pull-request';

type DiffProcessingOptions = {
  isWordDiffEnabled?: boolean;
};

// eslint-disable-next-line require-await
export async function processDiff(
  data: string,
  options: DiffProcessingOptions = {}
) {
  const parsedDiffs: Diff[] = diffParser(data);
  const amendedDiffs = amendChunks(parsedDiffs);
  const diffs = options.isWordDiffEnabled
    ? addWordDiffToDiffs(amendedDiffs)
    : amendedDiffs;
  return diffs;
}

// Helper to surface typings for consumers
export default function worker() {
  return { processDiff };
}
